// extracted by mini-css-extract-plugin
export var addButton = "_p9-0";
export var border = "_p9-8";
export var check = "_p9-h";
export var danger = "_p9-6";
export var dropdownContainer = "_p9-1";
export var editModalBody = "_p9-j";
export var footerContainer = "_p9-i";
export var fullWidth = "_p9-a";
export var hide = "_p9-9";
export var icon = "_p9-3";
export var input = "_p9-7";
export var inputFlex = "_p9-b";
export var inputWrapper = "_p9-c";
export var manualFocus = "_p9-5";
export var optionButton = "_p9-4";
export var pillWrapper = "_p9-e";
export var pointer = "_p9-2";
export var showOverflow = "_p9-f";
export var tagsFlex = "_p9-d";
export var xButton = "_p9-g";